import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { NotificationType } from 'src/core/decorators/notification/notification-type.decorator';
import { NotificationDto } from 'src/core/models/notification/notification.dto';

@Component({
  selector: 'ca-settings-notification',
  templateUrl: './settings-notification.component.html',
  styleUrls: ['./settings-notification.component.scss'],
  standalone: false,
})
@NotificationType('SettingsChangedNotification', SettingsNotificationComponent)
export class SettingsNotificationComponent implements OnInit {
  data: NotificationDto;

  constructor(private localizationService: LocalizationService) {}

  ngOnInit(): void {}

  get message(): string {
    if (!this.data || !this.data.payload) {
      return '';
    }
    try {
        const parsedPayload = JSON.parse(this.data.payload);
        return this.localizationService.instant(
          'Settings::CallAnalysisMetricsSettingsChangedNotification',
          parsedPayload.MinAgentSpeed,
          parsedPayload.MaxAgentSpeed,
          parsedPayload.MinMonotonicityRatio,
          parsedPayload.MaxMonotonicityRatio
        );
    } catch (e) {
        return '';
    }
  }

  static showNotification(
    notificationId: string,
    payload: string,
    toastr: ToasterService,
    localizationService: LocalizationService
  ) {
    try {
        const parsedPayload = JSON.parse(payload);
        const message = localizationService.instant(
          'Settings::CallAnalysisMetricsSettingsChangedNotification',
          parsedPayload.MinAgentSpeed,
          parsedPayload.MaxAgentSpeed,
          parsedPayload.MinMonotonicityRatio,
          parsedPayload.MaxMonotonicityRatio
        );
        
        if (message) {
            toastr.info(message);
        }
    } catch (e) {
        console.error('Error parsing notification payload', e);
    }
  }
}
